import api from '../client';

export const ReportsService = {
  getReports: (userId) => api.get('/reports', { params: { user_id: userId } }),
  getTodayReport: (userId) => api.get('/reports/daily/today', { params: { user_id: userId } }),
  createReport: (data) => api.post('/reports', data),
};
